import {
  GET_OBSERVATION_DETAILS_CLEAR_API_RES,
  GET_OBSERVATION_DETAILS_FAIL,
  GET_OBSERVATION_DETAILS_LOADING,
  GET_OBSERVATION_DETAILS_SUCCESS,
  GET_OBSERVATION_DETAILS_UPDATE_API_MSG,
  GetObservationAboutPatientDetailActionTypes,
} from "./ActionTypes";
import { GetObservationAboutPatientDetail } from "./Model";

export const getObservationAboutPatientDetailLoadingAction = (
  loading: boolean,
): GetObservationAboutPatientDetailActionTypes => {
  return {
    type: GET_OBSERVATION_DETAILS_LOADING,
    loading: loading,
  };
};

export const getObservationAboutPatientDetailSuccessAction = (
  getObservationAboutPatientDetailResponse: GetObservationAboutPatientDetail,
  successMsg: string,
  status: number,
): GetObservationAboutPatientDetailActionTypes => {
  return {
    type: GET_OBSERVATION_DETAILS_SUCCESS,    
    payload: getObservationAboutPatientDetailResponse,
    successMsg: successMsg,
  };
};

export const getObservationAboutPatientDetailErrorAction = (
  getObservationAboutPatientDetailResponse: GetObservationAboutPatientDetail,
  errMsg: string,
  status: number,
): GetObservationAboutPatientDetailActionTypes => {
  return {
    type: GET_OBSERVATION_DETAILS_FAIL,
    payload: getObservationAboutPatientDetailResponse,
    errorMsg: errMsg,
    status: status,
  };
};
export const getObservationAboutPatientDetailUpdateAPIMsgAction = (
  getObservationAboutPatientDetailResponse: GetObservationAboutPatientDetail,
  errMsg: string,
  status: number,
): GetObservationAboutPatientDetailActionTypes => {
  return {
    type: GET_OBSERVATION_DETAILS_UPDATE_API_MSG,
    payload: getObservationAboutPatientDetailResponse,
    errorMsg: errMsg,
    status: status,
  };
};

export const getObservationAboutPatientDetailAPIResClearAction = (
  getObservationAboutPatientDetailResponse: GetObservationAboutPatientDetail,
  errMsg: string,
  status: number,
): GetObservationAboutPatientDetailActionTypes => {
  return {
    type: GET_OBSERVATION_DETAILS_CLEAR_API_RES,
    payload: getObservationAboutPatientDetailResponse,
    errorMsg: errMsg,
    status: status,
  };
};
